import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Transform Your Vision into Reality with Expert Services"} subTitle={"Build with Confidence"} linear sideHeading />
        <Button link={"Get-Quote"} title={"Get Quote"} />

      </div>
    </section>
  );

};

export default Banner;